import { useState, useContext } from "react";
import { useUpdateReceiptCustomaizationDataMutation } from "../../../../hooks/api/mutations/useInventory";
import { RequestLoader, ToastContext } from "../../../../hooks/context";
import { cleanObject, getRandomIntInclusive } from "../../../../helpers";
import { useSelector } from "react-redux";
import { getBusiness } from "../../../../services/settings";
import { useDispatch } from "react-redux";
import { setBusinessDetails } from "../../../../store/modules/profile";

const useReceiptCustomaization = () => {
  const dispatch = useDispatch();
  const businessProfile = useSelector(
    (state) => state.profileDetailsReducer.businessDetails,
  );
  const [details, setDetails] = useState({
    title: businessProfile?.receipt_footer_title || "",
    description: businessProfile?.receipt_footer_description || "",
  });

  const triggerToast = useContext(ToastContext);
  const { setRequestLoaderProgress } = useContext(RequestLoader);
  const { mutate, isLoading } = useUpdateReceiptCustomaizationDataMutation();

  const onSubmitData = () => {
    setRequestLoaderProgress(getRandomIntInclusive(10, 50));
    const data = cleanObject({
      receipt_footer_title: details.title,
      receipt_footer_description: details.description,
    });
    mutate(data, {
      onSuccess: () => {
        triggerToast("Updated successfully", "success");
        getBusiness().then((response) => {
          dispatch(setBusinessDetails(response.data.data));
        });
      },
      onSettled: () => setRequestLoaderProgress(100),
    });
  };
  return {
    details,
    isLoading,
    setDetails,
    onSubmitData,
    businessProfile,
  };
};

export default useReceiptCustomaization;
